// React
import React, { useState } from "react";

// Styled component
import { TableContent } from "./UsersCard.styled";
import { Flex } from "../../../../style";

// Components
import ButtonLoading from "../../../../../components/Loader/ButtonLoading";

import { UsersWrapper } from "../ManageUsers.styled";
import { useTranslation } from "react-i18next";
import { Typography } from "../../../../../components/Typography";

const NoUsersCard = ({}) => {
  const [loading, setLoading] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      <ButtonLoading loading={loading} success={isLoaded} nobg />
      <UsersWrapper>
        <Flex align="flex-start" borderBottom>
          <TableContent>
            <Flex flexDirection="column" align="flex-start">
              <Typography tag="p" nomargin ml="0" large bold >
                No recruiters
              </Typography>
            </Flex>
          </TableContent>
        </Flex>
      </UsersWrapper>
    </>
  );
};

export default NoUsersCard;
